export const MARKUP_TYPES = ['big_webform_dsgvo_element', 'big_webform_submitting_markup', 'webform_markup'];
